import { dictionaryCamelCaseConverter } from 'src/utils/dictionaryCamelCaseConverter';

export const sanitizeCompanySizeEmployees = (data) => dictionaryCamelCaseConverter(data);
